import React from "react";
import { Link, useLocation } from "react-router-dom";

function Navbar() {

    const location = useLocation();

    return (
        <nav className="flex flex-row justify-around">
            <Link to="/mes/module" className={`${location.pathname === '/mes/module' ? 'bg-slate-600 text-white font-bold' : ''} w-full border border-gray-400 text-center p-2 hover:bg-gray-400`}>
                Module
            </Link>
            <Link to="/mes/plastic" className={`${location.pathname === '/mes/plastic' ? 'bg-slate-600 text-white font-bold' : ''} w-full border border-gray-400 text-center p-2 hover:bg-gray-200`}>
                Plastic
            </Link>
            <Link to="/mes/ip" className={`${location.pathname === '/mes/ip' ? 'bg-slate-600 text-white font-bold' : ''} w-full border border-gray-400 text-center p-2 hover:bg-gray-200`}>
                IP
            </Link>
        </nav>
    );
}

export default Navbar